import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
* Информация о канале с ID
* https://master.api-epg.sandbox.d2c.r-one.io/docs/#/v1/ChannelController_getProviderChannelById
*/

export const getChannelInfo = (id: number, providerId: number): IRequest => ({
    uri: `/api/v1/${providerId}/channels/${id}`,
    method: 'GET',
    queryParams: {
        with: 'channelInfo',
    },
    headers: {
        providerId: `${providerId}`,
    },
});
